/**
 * The receipt. It reports what already happened; it does not transact.
 *
 * A grant is effective from issuance, so the player is told rather than asked,
 * and the only control dismisses the card. The words say so outright, because
 * a card that looks like a claim teaches the wrong thing even when it writes
 * nothing (`docs/decisions/no-companion-and-no-claim.md`).
 */

import { packAsset, type AssetKey } from "./assets";
import type { WidgetTemplate } from "../data/contract";

export interface ReceiptContent {
  eyebrow: string;
  assetKey: AssetKey;
  title: string;
  subtitle: string;
  amount: string | null;
  fine: string;
  button: string;
}

interface Props {
  content: ReceiptContent;
  template: WidgetTemplate;
  onDismiss(): void;
}

export function Receipt({ content, template, onDismiss }: Props) {
  return (
    <div className="receipt on" role="dialog" aria-label={content.title}>
      <div className="r-card">
        <div className="r-eyebrow">{content.eyebrow}</div>
        <img className="r-img" src={packAsset(template, content.assetKey)} alt="" />
        <div className="r-title">{content.title}</div>
        <div className="r-sub">{content.subtitle}</div>
        {content.amount && (
          <div className="r-amt">
            <img src={packAsset(template, "coin")} alt="" />
            <span className="tnum">{content.amount}</span>
          </div>
        )}
        <button type="button" className="r-btn" onClick={onDismiss} autoFocus>
          {content.button}
        </button>
        <div className="r-fine">{content.fine}</div>
      </div>
    </div>
  );
}
